import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { pendingUsers } from '../../actions'
import classNames from 'classnames';

const PendingUser = ({ pendingUser }) => {

    const CreateUserErrorMessage = () => {
        if ( pendingUser.status === 'failed' ) {
            return(
                <ul className="new-list-view alert-danger">
                    <li>
                        <div className="list-view-item">
                            <div className="col col-70 col-indent">{pendingUser.message}</div>
                        </div>
                    </li>
                </ul>
            )
        } else {
            return null;
        }
    };

    console.log('Pending User: ', pendingUser);

    if ( pendingUser ) {
        console.log("Pending User: Component not null");
        return(
            <li>
                <div className={classNames("list-view-item",{"alert-warning" : (pendingUser.status === 'creating'), "" : (pendingUser.status === 'created'), "alert-danger" : (pendingUser.status === 'failed')})}>
                    <div title={pendingUser.email} className="col col-35">{pendingUser.username}</div>
                    <div className="col col-35">{pendingUser.role}</div>
                </div>
                <CreateUserErrorMessage/>
            </li>
        )
    } else {
        console.log("Pending User: Component null");
        return null;
    }
};


export default PendingUser


/** WEBPACK FOOTER **
 ** ./src/components/User/PendingUsers.js
 **/